import { AdvisorStatusDot } from './AdvisorStatusDot'

function timeShort(dateStr) {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const now = new Date()
  if (d.toDateString() === now.toDateString()) {
    return d.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' })
  }
  return d.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })
}

export function DMConversationRow({ conversation, isSelected, onClick, getStatus, isDarkMode }) {
  const adv = conversation.otherAdvisor
  const name = adv?.full_name || adv?.name || 'Unknown'
  const status = getStatus ? getStatus(adv?.id) : null

  return (
    <button
      onClick={onClick}
      className={`w-full text-left flex items-center gap-3 px-4 py-3 border-b transition-colors ${
        isSelected
          ? isDarkMode ? 'bg-slate-700' : 'bg-orange-50'
          : isDarkMode ? 'hover:bg-slate-700/50' : 'hover:bg-gray-50'
      } ${isDarkMode ? 'border-slate-700' : 'border-gray-100'}`}
    >
      <AdvisorStatusDot
        avatarUrl={adv?.avatar_url ?? null}
        fullName={name}
        size="md"
        status={status}
        isDarkMode={isDarkMode}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <p className={`text-sm font-semibold truncate ${isDarkMode ? 'text-slate-200' : 'text-sfp-darkgray'}`}>
            {name}
          </p>
          <span className={`text-xs flex-shrink-0 ml-2 ${isDarkMode ? 'text-slate-500' : 'text-gray-400'}`}>
            {timeShort(conversation.last_message_at)}
          </span>
        </div>
        {conversation.last_message_preview && (
          <p className={`text-xs truncate mt-0.5 ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}>
            {conversation.last_message_preview}
          </p>
        )}
      </div>
      {conversation.unreadCount > 0 && (
        <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-sfp-orange text-white text-[10px] font-bold flex-shrink-0">
          {conversation.unreadCount > 99 ? '99+' : conversation.unreadCount}
        </span>
      )}
    </button>
  )
}
